module.exports = __webpack_public_path__ + "static/media/map.4bf6ca26.svg";